<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <mentee-sidebar-menu :show_menu="true" :show_back_button="false" />
      <div class="content-wrapper"  style="padding-left: 165px;">
        <div class="container-wrapper center">

          <div class="row">
            <div class="col-12 p-0 pl-2">
              <h3 class="heading text-uppercase mb-3">{{ menteeShortName }}</h3>
            </div>
            <div class="col-7 pr-3 pr-xl-5">

              <div class="row justify-content-between custom-pl-15 pb-4" v-if="menteeCountLoading == true">
                <div class="col pl-0 pr-2" >
                  <PuSkeleton height="150px" :count="1"></PuSkeleton>
                </div>
                <div class="col pl-4" >
                  <PuSkeleton height="150px" :count="1"></PuSkeleton>
                </div>
                <div class="col pl-4 pr-1" >
                  <PuSkeleton height="150px" :count="1"></PuSkeleton>
                </div>
              </div>



              <div class="row justify-content-between custom-pl-15" v-if="menteeCountLoading == false">
                <div class="col pl-0 pr-lg-2">
                  <div class="shadow p-3 information_box">
                    <div class="information_box_title">Reps Submitted</div>
                    <div class="h3">{{ repCount }}</div>

                    <span v-if="(previousWeekRepCount < currentWeekRepCount)" class="small px-2 py-1 information_box_text_up">
                      <img class="mr-1 stats_icon" src="@/assets/manager/up_tick_icon.png" />
                      Up {{ parseInt(currentWeekRepCount - previousWeekRepCount)}} this week</span>
                    <span v-else-if="(previousWeekRepCount > currentWeekRepCount)" class="small px-2 py-1 information_box_text_down">
                      <img class="mr-1 stats_icon" src="@/assets/manager/down_tick_icon.png" />
                      Down {{ parseInt(previousWeekRepCount - currentWeekRepCount)}} this week</span>
                    <span v-else class="small px-2 py-1">&nbsp;</span>
                    
                  </div>                  
                </div>
                <div class="col pr-0" style="cursor: pointer;" @click="competencyReport()">
                  <div class="shadow p-3 information_box">
                    <div class="information_box_title">Competencies</div>
                    <div class="h3">{{ currentWeekCompetencyCount }}</div>

                    <span v-if="(previousWeekCompetencyCount < currentWeekCompetencyCount)" class="small px-2 py-1 information_box_text_up">
                      <img class="mr-1 stats_icon" src="@/assets/manager/up_tick_icon.png" />
                      Up {{ parseInt(currentWeekCompetencyCount - previousWeekCompetencyCount)}} this week</span>
                    <span v-else-if="(previousWeekCompetencyCount > currentWeekCompetencyCount)" class="small px-2 py-1 information_box_text_down">
                      <img class="mr-1 stats_icon" src="@/assets/manager/down_tick_icon.png" />
                      Down {{ parseInt(previousWeekCompetencyCount - currentWeekCompetencyCount)}} this week</span>
                    <span v-else class="small px-2 py-1">&nbsp;</span>

                  </div>                  
                </div>

                <div class="col px-xl-4 px-lg-2">
                  <div class="shadow p-3 information_box">
                    <div class="information_box_title">Reps to Review</div>
                    <div class="h3">{{ repsReviewCount }}</div>

                    <span v-if="(previousWeekRepReviewCount < currentWeekRepReviewCount)" class="small px-2 py-1 information_box_text_up">
                      <img class="mr-1 stats_icon" src="@/assets/manager/up_tick_icon.png" />
                      Up {{ parseInt(currentWeekRepReviewCount - previousWeekRepReviewCount)}} this week</span>
                    <span v-else-if="(previousWeekRepReviewCount > currentWeekRepReviewCount)" class="small px-2 py-1 information_box_text_down">
                      <img class="mr-1 stats_icon" src="@/assets/manager/down_tick_icon.png" />
                      Down {{ parseInt(previousWeekRepReviewCount - currentWeekRepReviewCount)}} this week</span>
                    <span v-else class="small px-2 py-1">&nbsp;</span>

                  </div>                  
                </div>
              </div>
              <div style="clear: both; margin-bottom: 10px;"></div>
              <!-- Pathway Step Progress -->

              <div class="row">
                <div class="col mt-1 mb-3 pr-3 custom-pl-15">
                  <div class="row align-items-end">
                    <div class="col pr-2 text-center" v-for="(pathwayStep, index) in pathwayStepsData.mentee_pathway_steps">
                      <p class="text-uppercase mb-1 " 
                        :class="activeStep == pathwayStep.id ? 'pw_step_title_active' : 'pw_step_title'" @click="moveToStep(pathwayStep.id)" style="cursor: pointer;">
                        <span :style="activeStep == pathwayStep.id ? 'background-color: ' + pathwayStepsData.mentee_pathway.ascentColor + ';' : ''">{{ pathwayStep.stepTitle }}</span>
                      </p>
                      <div class="progress progress_pathway">
                        <div class="progress-bar progress_bar_100" :style="'width:' + pathwayStep.percentage_completion + '%;'"></div>
                      </div>
                    </div>        
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="pr-2 custom-pl-15">
                  <div class="text-muted">Mentor(s)</div>
                    <ul class="list-inline">
                      <li class="list-inline-item font-weight-bold" v-for="(mentorAssigned, index) in mentorsAssigned" :key="index">{{ mentorAssigned.name }}</li>
                    </ul>                
                </div>
              </div>

              <div v-if="activeStep != ''">
                <MenteeProgress
                  :stepId="activeStep"
                  :pathwayId="pathwayId"
                  ref="MenteeProgressComponent"
                  >
                </MenteeProgress>
              </div>



              </div>
              
              <div class="col-5 pl-4 pl-xl-4 pr-3 pr-xl-5">    

                <div class="col-12 mb-3 p-0" >
                  <div class="shadow rounded px-2 py-1">
                    <div class="h4 mt-1 mb-1">Reports</div>

                    <div class="row justify-content-center mb-2">
                      <router-link :to="{ name: 'menteepathwayprogressreportsdetails' }" class="text-muted">
                      <div class="report-panel rounded text-center p-1 text-muted" style="border-color: #002F42 !important">
                          <img class="" src="@/assets/manager/Mentor Mentee Progress Report Icon.png" style="width: 25px; margin-top: 5px; margin-bottom: 5px;" />
                          <p class="mb-0 small" style="color: #002F42;">Progress</p>
                      </div>

                      </router-link>
                      <router-link :to="{ name: 'menteecompetencyreport' }" class="text-muted">
                      <div class="report-panel rounded text-center p-1 text-muted" style="border-color: #002F42 !important">
                          <img class="" src="@/assets/manager/competency_report_icon.png" style="width: 19px; margin-top: 5px; margin-bottom: 5px;" />
                          <p class="mb-0 small" style="color: #002F42;">Competency</p>
                      </div>
                      </router-link>


                      <router-link  :to="{ name: 'menteeRepAuditTrail' }" class="text-muted">
                      <div class="report-panel rounded text-center p-1 mx-2 text-muted" style="border-color: #002F42 !important;">
                          <img class="" src="@/assets/manager/tasks_icon_rep_audit_trail.png" style="width: 22px; margin-top: 5px; margin-bottom: 10px;" />
                          <p class="mb-0 small" style="color: #002F42;">Tasks</p>
                      </div>
                      </router-link>

                      <router-link :to="{ name: 'menteecompetencyaudittrail' }" class="text-muted">
                      <div class="report-panel rounded text-center p-1 text-muted" style="border-color: #002F42 !important">
                          <img class="" src="@/assets/manager/Competency_audit_button.png" style="width: 19px; margin-top: 5px; margin-bottom: 5px;" />
                          <p class="mb-0 small" style="color: #002F42;">Competency Audit</p>
                      </div>
                      </router-link>

                    </div>
                  </div>
                </div>

                <div v-if="menteeId > 0" style="margin-top: 20px;">
                    <MenteeTasksLogged
                    :menteeId="menteeId"
                    ></MenteeTasksLogged>
                </div>
              </div>
          </div>
          </div>
        
        <!-- Bell icon to see the introduction slide -->
        <div class="fixed-bell-icon btn btn-primary d-none-" @click="showIntroductionSlide" v-if="showSlideNumbers == true">
           <i class="fa fa-bell" aria-hidden="true"></i>       
        </div>



        </div>
      </div>

    <IntroductionModal
      :isIntroductionModalVisible="isIntroductionModalVisible"
      :introductionSlideObj="introduction_slide_obj"
      :showSlideNumbers="showSlideNumbers"
      ref="introduction_modal"
      @goToAssessmentLanding="goToAssessmentLanding"
      @close="isIntroductionModalVisible = false">
    </IntroductionModal>

    <MenteeAssessmentLandingPage 
      :isModalVisible="isAssessmentLandingVisible"
      @closeAssessmentLandingModal="closeAssessmentLandingModal"
      @openAssessmentQuestionModal="openAssessmentQuestionModal"
      ref="MenteeAssessmentLandingModal">
    </MenteeAssessmentLandingPage>

    <MenteeAssessmentQuestionPage 
      :isModalVisible="isAssessmentQuestionVisible"
      @closeAssessmentQuestionModal="closeAssessmentQuestionModal"
      ref="MenteeAssessmentQuestionModal">
    </MenteeAssessmentQuestionPage>

    <EndUserLicenseAgreementModal
      :isModalVisible="isEndUserLicenseAgreementModalVisible" 
      @close="closeEndUserLicenseModal"
      ref="end_user_license_agreement"               
       />


    </div>
  </div>
</template>


<script>
import axios from 'axios'
import { store } from '../../store/store';
import router from '../../router/index.js';
import UserMenu from '../shared/user_menu.vue';
import MenteeSidebarMenu from '@/components/shared/mentee_sidebar_menu.vue';
import MenteeTasksLogged from '@/components/mentee/mentee_tasks_logged.vue';
import MenteeMyRepetitions from '@/components/mentee/my_repetitions.vue';
import MenteeProgress from '@/components/mentee/mentee_progress.vue';
import MyRepetitions from '@/components/mentee/my_repetitions.vue';
import IntroductionModal from '@/components/manager/introductionManagerTemplateModal.vue';
import MenteeAssessmentLandingPage from '@/components/mentee/mentee_assessment_landing_new.vue';
import MenteeAssessmentQuestionPage from '@/components/mentee/mentee_assessment_question_new.vue';
import EndUserLicenseAgreementModal from '@/components/shared/end_user_license_agreement_modal.vue';

const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
  data: function () {
    return {
      loading: false,
      accountName: '',
      repCount: '',
      previousWeekRepCount: '',
      currentWeekRepCount: '',
      repsReviewCount: '',
      previousWeekRepReviewCount: '',
      currentWeekRepReviewCount: '',
      competencyEarnedCount: '',
      previousWeekCompetencyCount: '',
      currentWeekCompetencyCount: '',
      pathwayStepsData: [],
      activeStep: '',
      pathwayId: '',
      showFutureSteps: false,
      mentorsAssigned: [],
      menteeShortName: '',
      menteeId: '',
      introduction_slide_obj: [],
      isIntroductionModalVisible: false,
      showSlideNumbers: false,
      isAssessmentLandingVisible: false,
      isAssessmentQuestionVisible: false,
      menteeCountLoading: false,
      isEndUserLicenseAgreementModalVisible: false,

    }
  },
  components: {
    UserMenu,
    MenteeSidebarMenu,
    MenteeTasksLogged,
    MenteeMyRepetitions,
    MenteeProgress,
    MyRepetitions,
    IntroductionModal,
    MenteeAssessmentLandingPage,
    MenteeAssessmentQuestionPage,
    EndUserLicenseAgreementModal,
  },
  methods: {
    closeEndUserLicenseModal() {
      this.isEndUserLicenseAgreementModalVisible = false;
      this.getIntroductionTemplate();
    },
    competencyReport() {
      router.push("/mentee-competency-report");
    },
    goToAssessmentLanding(assessmentId, assessmentAttemptId) {
      this.$refs.MenteeAssessmentLandingModal.getLandingPageContent(assessmentId, assessmentAttemptId);
      this.isAssessmentLandingVisible = true;
    },
    closeAssessmentLandingModal() {
      this.isAssessmentLandingVisible = false;
    },
    openAssessmentQuestionModal(assessmentId, assessmentAttemptId) {
      this.$refs.MenteeAssessmentQuestionModal.getScaleLists(assessmentId, assessmentAttemptId);
      this.isAssessmentLandingVisible = false;
      this.isAssessmentQuestionVisible = true;
    },
    closeAssessmentQuestionModal () {
      this.isAssessmentQuestionVisible = false;
    },
    showIntroductionSlide() {
      this.$refs.introduction_modal.getDefaultSlide();
      this.isIntroductionModalVisible = true;      
    },
    moveToStep(stepId) {
      if(this.showFutureSteps == true) {
        this.activeStep = stepId;
        this.$refs.MenteeProgressComponent.reloadStep(stepId);
      }
    },
    getAccountStatistics() {
      this.menteeCountLoading = true;
      axios.get('/desktop/v2/mentee/account-statistics', {
        params: {
          account_id: this.$store.state.user_accountid,
        }
      })
      .then(response =>  {
        this.menteeCountLoading = false;
        var licenseflag = response.data.eulaFlag;
        if(licenseflag == 0) {
          this.isEndUserLicenseAgreementModalVisible = true;
        }
        if(this.isEndUserLicenseAgreementModalVisible == false) {
          this.getIntroductionTemplate();
        }
        this.repCount = response.data.repCount;
        this.previousWeekRepCount = response.data.previousWeekRepCount;
        this.currentWeekRepCount = response.data.currentWeekRepCount;
        this.repsReviewCount = response.data.repsReviewCount;
        this.previousWeekRepReviewCount = response.data.previousWeekRepReviewCount;
        this.currentWeekRepReviewCount = response.data.currentWeekRepReviewCount;
        this.competencyEarnedCount = response.data.competencyEarnedCount;
        this.previousWeekCompetencyCount = response.data.previousWeekCompetencyCount;
        this.currentWeekCompetencyCount = response.data.currentWeekCompetencyCount;
      })
      .catch(function() {
        
      });

    },
    getIntroductionTemplate() {
      axios.get('/get-dashboard-introduction-slide', {
        params: {
          user_roles: (this.$route.name == "apprenticedashboard") ? 'ROLE_APPRENTICE' : 'ROLE_MENTEE',
          accountId: this.$store.state.user_accountid,
        }
      })
      .then(response =>  {
        this.introduction_slide_obj = response.data.introduction_slide;
        this.showSlideNumbers = response.data.showSlideNumbers;
        if(this.introduction_slide_obj.length > 0) {
          if(this.$store.state.introduction_template_display == 1) {
            setTimeout(() => {
              this.$refs.introduction_modal.getDefaultSlide();
              this.isIntroductionModalVisible = true;
              this.$store.dispatch('introduction_template_display', 0);
            }, 1000);
          }
        }
      })
      .catch(function() {
        
      });
    },

  },

  created() {
    this.menteeCountLoading = true;
    if(this.$store.state.user_locations) {
      //this.accountName = this.$store.state.user_locations.locations.find(loc => loc.accId === this.$store.state.user_accountid).accountName;
    }
    var roles = store.state.roles;
    this.getAccountStatistics();

    axios('/desktop/v2/get-mentee-details', {
      method: 'GET',
      params: {
        accountId: this.$store.state.user_accountid, 
      }
    })
    .then(resp => {
      let data = resp.data;
      this.menteeId = data.mentee_id;
      this.menteeShortName = data.mentee_short_name;
      this.mentorsAssigned = data.mentors_assigned;
      this.pathwayStepsData = data.menteePathway;
      this.activeStep = this.pathwayStepsData.mentee_pathway.currentStep;
      this.pathwayId = this.pathwayStepsData.mentee_pathway.id;
      this.showFutureSteps = this.pathwayStepsData.mentee_pathway.showFutureSteps;
    })
    .catch(() => {});



  },  
}
</script>

<style>
@import '../../assets/styles/style_v2.css';
</style>
<style scoped>
.content-wrapper {
  padding-top: 75px;
}
.container-wrapper .heading {
  font-size: 28px;
  font-weight: normal;
}
.modal-header .sub-heading h3 {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}
.stats_icon {
  width: 8px !important;
}
.progress_pathway {
  height:5px;
  margin-top: 5px;
}
.pw_step_title {
  font-size: 12px;
}
.pw_step_title_active {
  font-size: 12px;
}
.pw_step_title_active span {
  color: #FFFFFF;
  padding: 0px 6px;
  border-radius: 4px;
  display: inline-block;
}

.fixed-bell-icon {
    position: fixed;
    right: 15px;
    bottom: 30px;
    border-radius: 50%;
    box-shadow: 1px 1px 11px 1px #a59a9a;
    font-size:25px;
    background-color: #29A3E4 !important;
    border-color: #29A3E4 !important; 
    cursor: pointer;
}
.information_box_text_up {
  border-radius: 5px;
  background-color: #D8F2FC;
}

.information_box_text_up i {
  color: #4DB1D8;
  transform: rotate(45deg);
}
.information_box_text_down {
  border-radius: 5px;
  background-color: #FBD9CC;

}
.information_box_text_down i {
  color: #F16733;
  transform: rotate(315deg);
}
@media (max-width: 1450px) {
  .report-panel {
    width: 85px;
  }
}
@media (min-width: 1451px) {
  .report-panel {
    width: 112px;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/mentee/mentee_dashboard.vue